export const faqTranslations = {
  // FAQ页面相关翻译
  "frequentlyAskedQuestions": {
    en: "Frequently Asked Questions",
    zh: "常见问题"
  },
  "faqDesc": {
    en: "Find answers to common questions about visiting, studying, and living in Penang, Malaysia.",
    zh: "查找有关马来西亚槟城的访问、学习和生活的常见问题答案。"
  },
  "searchForQuestions": {
    en: "Search for questions...",
    zh: "搜索问题..."
  },
  "allCategories": {
    en: "All Categories",
    zh: "所有类别"
  },
  "noQuestionsFound": {
    en: "No questions found matching your search.",
    zh: "未找到符合您搜索条件的问题。"
  },
  "clearFilters": {
    en: "Clear filters",
    zh: "清除筛选"
  },
  "didntFindWhatYoureLookingFor": {
    en: "Didn't find what you're looking for?",
    zh: "没有找到您要找的内容？"
  },
  "contactUsMessage": {
    en: "If you couldn't find the answer to your question, feel free to contact us directly. Our team is ready to help!",
    zh: "如果您未能找到问题的答案，请随时直接联系我们。我们的团队随时准备帮助您！"
  },
  "contactUs": {
    en: "Contact Us",
    zh: "联系我们"
  },
  "liveChatSupport": {
    en: "Live Chat Support",
    zh: "在线客服支持"
  },
  // FAQ问题类别
  "Immigration": {
    en: "Immigration",
    zh: "移民"
  },
  "StudentServices": {
    en: "Student Services",
    zh: "学生服务"
  },
  "Accommodation": {
    en: "Accommodation",
    zh: "住宿"
  },
  "Transport": {
    en: "Transport",
    zh: "交通"
  },
  "LifeServices": {
    en: "Life Services",
    zh: "生活服务"
  },
  "TravelGuide": {
    en: "Travel Guide",
    zh: "旅游指南"
  }
};

export default faqTranslations;
